import { FC } from "react";
import { twMerge } from "tailwind-merge";

interface Verify2FAProps {
  text: string;
  buttonText: string;
  onClick: (e: React.MouseEvent) => void;
  className?: string;
  buttonClassName?: string;
}

const Verify2FA: FC<Verify2FAProps> = ({
  text,
  buttonText,
  onClick,
  className,
  buttonClassName,
}) => {
  return (
    <div className={twMerge("z-2 pointer-events-none absolute inset-0 flex items-center justify-center bg-[rgba(0,0,0,0.7)] ", className)}>
      <div className="rounded-xl px-6 pointer-events-auto max-w-[454px] py-5 text-center text-white max-md:max-w-[260px]">
        <i className="icomoon h-[19px] w-[30px] mx-auto  text-3xl before:content-['\e95D']" />
        <div className="my-3 text-sm md:text-base">{text}</div>
        <button
          type="button"
          className={twMerge("inline-flex min-w-[160px] h-[42px] cursor-pointer items-center justify-center rounded-[200px] bg-gradient-to-r from-[#FF6700] to-[#FF8900] px-6 py-3 text-sm font-medium leading-[18px] text-white max-md:min-w-[67px] max-md:h-[24px] max-md:px-3 max-md:py-1 max-md:text-xs", buttonClassName)}
          onClick={onClick}
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default Verify2FA;
